import { render } from "./SlotDetailsModal.vue?vue&type=template&id=70095eb7&scoped=true"
import script from "./SlotDetailsModal.vue?vue&type=script&lang=js"
export * from "./SlotDetailsModal.vue?vue&type=script&lang=js"

import "./SlotDetailsModal.vue?vue&type=style&index=0&id=70095eb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70095eb7"]])

export default __exports__